import styled from 'styled-components';
import {PCBox as BasePcBox, MobileBox as BaseMobileBox} from '../../../../basic-components/layout-wrapper/layout-wrapper.default.box';
import {HOME_PAGE} from '../../../../themes/css-global-classes';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';

const PcBox = BasePcBox;
//minHeight 400 is there as a temporary fix for bug 1731336, if we want good web vitals score on miniOrbit we ll need to find a proper value
const MobileBox = styled(BaseMobileBox)`

    min-height: 400px;
    padding-top: 1.5rem;

    .${HOME_PAGE} &{
        margin-top: 0;
    }
`;

export const MiniOrbitHomePageDefaultBox = styledByDevice(PcBox, MobileBox);


